import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { Divider } from 'components/Divider/Divider';
import { Hide } from 'components/Hide/Hide';
import { useI18n } from 'i18n/hooks/useI18n';
import type { ApiOrg } from 'modules/listing/orgs/api/types/ApiOrg';
import { spacing } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE } from 'utils/constants/general/listingTypeHumanNameMapTitle';

import { orgHasListings } from './utils/orgHasListings';

type Props = {
  org: ApiOrg;
};

export function ViewOrgPageSidebarHeader({ org }: Props) {
  const { i18n } = useI18n();

  const jobCount = org.jobs.length;
  const internshipCount = org.internships.length;
  const volopCount = org.volops.length;
  const eventCount = org.events.length;

  const hasListings = orgHasListings(org);

  return (
    <>
      {jobCount > 0 && (
        <Button
          type="link"
          variant="tertiary"
          href="?tab=JOB#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.JOB} Link`,
            });
          }}
        >
          {jobCount > 1
            ? i18n('%(jobCount)s current jobs', { jobCount })
            : i18n('%(jobCount)s current job', { jobCount })}
        </Button>
      )}
      {internshipCount > 0 && (
        <Button
          type="link"
          variant="tertiary"
          href="?tab=INTERNSHIP#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.INTERNSHIP} Link`,
            });
          }}
        >
          {internshipCount > 1
            ? i18n('%(internshipCount)s current internships', {
                internshipCount,
              })
            : i18n('%(internshipCount)s current internship', {
                internshipCount,
              })}
        </Button>
      )}

      {volopCount > 0 && (
        <Button
          type="link"
          variant="tertiary"
          href="?tab=VOLOP#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.VOLOP} Link`,
            });
          }}
        >
          {volopCount > 1
            ? i18n('%(volopCount)s current volunteer opportunities', {
                volopCount,
              })
            : i18n('%(volopCount)s current volunteer opportunity', {
                volopCount,
              })}
        </Button>
      )}

      {eventCount > 0 && (
        <Button
          type="link"
          variant="tertiary"
          href="?tab=EVENT#opportunities"
          onClick={() => {
            trackClicked('See Opportunities', {
              type: `${LISTING_TYPE_HUMAN_TRACKING_NAME_MAP_TITLE.EVENT} Link`,
            });
          }}
        >
          {eventCount > 1
            ? i18n('%(eventCount)s current events', { eventCount })
            : i18n('%(eventCount)s current event', { eventCount })}
        </Button>
      )}

      <Hide xs sm>
        {hasListings && (
          <Box mt={spacing[16]}>
            <Button
              type="link"
              href="#opportunities"
              onClick={() => {
                trackClicked('See Opportunities', { type: 'Button Left' });
              }}
              variant="primary"
            >
              {i18n('See opportunities')}
            </Button>
          </Box>
        )}
      </Hide>

      {hasListings ? <Divider marginTop={24} marginBottom={24} /> : null}
    </>
  );
}
